import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import autoBind from "react-autobind";
import navbarSelectors from "@common/store/navbar/navbar.selectors";
import navbarActions from "@common/store/navbar/navbar.actions";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import NavbarMenuAction from '@common/components/navbar/menu/navbar.menuAction';

class NavbarFavorite extends Component {
  constructor(props) {
    super(props);

    autoBind(this);

    this.state = {
      showInfo: false,
      filter: '',
      menuSearchFiltered: [],
      favoritePages: [],
      resultFavoritos: [],
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.routerManager.currentUrl !== prevProps.routerManager.currentUrl) {
      this.props.navbarActions.iconFavoriteByUrl(this.props.routerManager.currentUrl);
    }
  }

  callFavorite() {
    this.props.navbarActions.calculateFavoriteByUrl(this.props.routerManager.currentUrl);
  }

  removeFromFavorites(item){
    this.props.navbarActions.removePageFromFavorite(item.IdFavorito);
  }

  UNSAFE_componentWillReceiveProps() {
    const { menuSearch, favoritosSelecionados } = this.props.navbarSelectors;
    this.setState({ 
      favoritePages: menuSearch,
      resultFavoritos: favoritosSelecionados
    });
  }

  showInfo() {
    this.setState({ showInfo: true });
  }

  hideInfo() {
    this.clearFilter();
    this.setState({ showInfo: false });
  }

  async handleChange(event) {
    const filter = event.target.value;

    await this.setState({ filter });
    this.applyFilter();
  }

  applyFilter() {
    const favoritePages = favoriteIcon ? favoriteIcon : "";

    this.setState({ favoritePages })
  }

  clearFilter() {
    const { menuSearch } = this.props.navbarSelectors;
    this.setState({ filter: '', favoritePages: menuSearch });
  }
  
  stopPropagation(event) {
    event.stopPropagation();
  }

  render() {
    const { favoriteIcon } = this.props.navbarSelectors;
    const { showInfo, resultFavoritos } = this.state;

    return (
      <OverlayTrigger
        placement="bottom"
        overlay={favoriteIcon ? <Tooltip></Tooltip> : <Tooltip></Tooltip>}
      >
      <div className="search-container mr-2" onMouseEnter={this.showInfo} onMouseLeave={this.hideInfo}>
        <div className="search-content">
          <i className={(favoriteIcon ? "fas" : "far") + " fa-star" + ((favoriteIcon && " favouriteIcon") || "")} onClick={this.props.activeClick ? this.callFavorite : () => {}} />
          {showInfo && (
            <div className="search-info">
              {resultFavoritos.length != 0 && (
                <ul>
                  {resultFavoritos?.map((item, index) => (
                    <li key={index} className="flex">
                      <a href={"#"+item.Url} className="nav-header-submenu-item-link link-menu-search">
                        <i className="fas fa-star ml-3 mb-2 mr-2" style={{color: '#FFC125'}}/>
                        {item.Nome}
                      </a>
                      <div className="box-more-actions">
                        <i className="fa fa-trash" style={{color: '#8e342a'}} onClick={() => this.removeFromFavorites(item)}/>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
              {resultFavoritos.length == 0 && (
                <ul>
                  <li key={'semPaginasFavoritadas'} className="flex">
                      <a className="ml-5">
                        Nenhum item adicionado aos favoritos.
                      </a>
                  </li>
                </ul>
              )}
            </div>
          )}
        </div>
      </div>
    </OverlayTrigger>
    );
  }
}

export default connect({
  selectors: {
    navbarSelectors
  },
  actions: {
    navbarActions
  }
})(NavbarFavorite);
